export default __webpack_public_path__ + "static/media/video.6351c47b.mp4";